import { jwtDecode } from 'jwt-decode';
import * as Sentry from '@sentry/react';

function getTokenExpiryTimeInSeconds(token) {
  try {
    const decoded = jwtDecode(token);

    if (!decoded.exp) {
      throw new Error('Token does not have an exp field');
    }

    const currentTimeInSeconds = Math.floor(Date.now() / 1000);
    const maxAge = decoded.exp - currentTimeInSeconds;

    return maxAge > 0 ? maxAge : 0;
  } catch (error) {
    Sentry.captureException(error);
    return 0;
  }
}

export default getTokenExpiryTimeInSeconds;
